module.exports = __webpack_public_path__ + "img/1.32ad37c7.png";